export {
  default,
  createErrorMessage,
  createInfoMessage
} from './GenericMessage'
